import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import TextWidget from '../Widget/TextWidget';

const menuData = [
  { title: 'Accueil', href: '/' },
  { title: 'À propos', href: '/about' },
  { title: 'Examens', href: '/departments' },
  { title: 'Bilan entreprise', href: '/bilan-entreprise' },
  { title: 'Patients internationaux', href: '/patients-internationaux' },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/icvt.png"
            alt="ICVT"
            className="cs_footer_brand_icon"
          />
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="cs_footer_item">
                <TextWidget text="Institut Cardiovasculaire <br />Trocadéro" />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item">
                <MenuWidget data={menuData} />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item">
                <a href="tel:+33156910846" className="cs_btn cs_style_1">
                  <span>Appeler</span>
                  <i>
                    <img src="/images/icons/arrow_white.svg" alt="" />
                    <img src="/images/icons/arrow_white.svg" alt="" />
                  </i>
                </a>
                <div className="cs_height_20" />
                <a
                  href="https://www.doctolib.fr/cabinet-medical/paris/icvt"
                  className="cs_btn cs_style_1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Doctolib</span>
                  <i>
                    <img src="/images/icons/arrow_white.svg" alt="" />
                    <img src="/images/icons/arrow_white.svg" alt="" />
                  </i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <div className="cs_copyright">
              Copyright © 2026 ICVT. Tous droits réservés.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
